(function(){
    'use strict'; 
    angular.module('Services').service('CasesTable', CasesTable); 
    CasesTable.$inject = [
        'TableLiteFactory'
    ]; 

    function CasesTable(
        TableLiteFactory
    ){
        return function(data){
            const headers = [{
                label: 'DESCRIPTION', 
                viewName: 'descriptionEdit', 
                fieldname: 'description', 
                intput: 'text', 
                hasError: function(row, name) {
                }, 
            }]; 

            const tableData = {
                form: data.form, 
                config: {
                    tableMinHeight: '200px', 
                    noPagination: true, 
                    noHeaders: false, 
                    noItemView: true, 
                    noFooter: true
                }, 
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary', 
                        label: 'Add Case', 
                        onClick: function(){
                            const item = angular.extend(buildValues({}), {isNew: true});
                            item.action.buttons[0].action(item);
                            tableData.data.push(item);
                        }, 
                        hide: function(){
                        }
                    }]
                },
                headers: [...headers, {
                    label: 'Action', 
                    viewName: 'action',
                    width: '150px'
                }], 
                data: [], 
            }

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(callback){
                    callback({content: data.cases})
                }, 
                callbackFormat:['success', 'error', 'filter'], 
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20, 
                    page: 0, 
                    sort: 'id,desc'
                }
            });

            function buildTableData(data){
                if(!data) { return tableData; }
                tableActions.initializeTableData(data); 
                angular.forEach(data.content, row => {
                    tableData.data.push(angular.exetend(row, buildValues(row)));
                });
            }

            function buildValues(data){
                const row = data; 
                headers.map(header => {
                    const valTemp = row[header.fieldname]; 
                    row[header.viewName] = {
                        url: '/templates/pages/accounting/create-case-table-cells/editable.html',
                        value: row[header.fieldname], 
                        inputType: header.inputType, 
                        valueFormatted: valTemp, 
                        error: {
                            hassError: header.hasError
                        }
                    }
                });

                const action = {
                    type: 'button', 
                    buttons:[{
                        class: 'btn-primary btn-circle glyphicon glyphicon-pencil', 
                        action: row => {
                            if(!row.editMode){
                                tableData.form.$setPristine(); 
                                headers.map(header => {
                                    row[header.viewName].valTemp = angular.copy(row[header.viewName].value); 
                                });
                                row.editMode = true;
                                changeButtons(row);
                                return false;
                            }
                            else {
                                tableData.form.$setSubmitted();
                                if(tableData.form.$invalid){
                                    return false;
                                }
                                updateCreateCase(row);
                                changeButtons(row);
                                return false;
                            }
                        }
                    }, {
                        class: 'btn btn-danger btn-circle glyphicon glyphicon-trash', 
                        action: row =>{
                            if(row.editMode) {
                                row.editMode = false;
                                changeButtons(row);
                                return false;
                            } 
                            else {
                                tableData.data.splice(tableData.data.indexOf(row), 1);
                                return false;
                            }
                        }
                    }]
                }

                function updateCreateCase(row) {
                    row.editMode = false; 
                    row.description = row.descriptionEdit.valTemp; 
                    row.descriptionEdit.valueFormatted = row.descriptionEdit.valTemp; 
                    row.descriptionEdit.value = row.descriptionEdit.valTemp;
                }

                function changeButtons(row){
                    if(row.editMode){
                        row.action.buttons[0].class = 'btn btn-success btn-circle glyphicon glyphicon-ok'; 
                        row.action.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-remove';
                        return false;
                    }

                    row.action.buttons[0].class = 'btn btn-primary btn-circle glyphicon glyphicon-pencil'; 
                    row.action.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-trash';
                }

                row.action = action; 
                return row;
            }

            function getApiPayload(){
                const cases = tableData.data.filter(data => {
                    return data.description != undefined;
                });
                return cases.map(data => {
                    return {
                        description: data.description, 
                        resolve: data.resolve ? data.resolve : false
                    }
                });
            }

            this.getApiPayload = getApiPayload;
            this.tableData = tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/CasesTable.js